module.exports = __webpack_public_path__ + "static/media/ipad_pro.f5f8cc98.png";